const STEPS = [
  'Conéctate 5 minutos antes desde una zona quieta sin distracciones',
  'Usa audífonos y asegúrate de tener buena conexión a internet',
  'Ten lápiz y papel a la mano para tomar notas importantes',
  'Prepara: tu facturación actual, número de clientes, mayor reto y meta a 90 días',
  'Llega con mente abierta y completamente comprometido',
];

export function StepsBeforeSession() {
  return (
    <div className="hit-card mb-4">
      <h3 className="text-sm font-extrabold uppercase tracking-widest text-hit-gray-dark mb-4">
        ⚠️ Importante: Prepárate para tu sesión
      </h3>
      <p className="text-sm text-hit-gray-dark mb-4">
        Solo trabajamos con personas comprometidas. Asegúrate de:
      </p>
      <ul className="flex flex-col gap-3">
        {STEPS.map((step, i) => (
          <li key={i} className="flex items-start gap-3 text-sm text-hit-black">
            <span className="flex-shrink-0 text-emerald-500 font-bold text-base leading-snug">
              ✅
            </span>
            <span>{step}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
